import { render, staticRenderFns } from "./EditAchievement.vue?vue&type=template&id=c631de6a&"
import script from "./EditAchievement.vue?vue&type=script&lang=js&"
export * from "./EditAchievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports